module.exports = {
      id: "slider-right-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#slider-right-arrow",
      toString: function () {
        return this.url;
      }
    }